import { render } from "./GroupLayoutRenderer.vue?vue&type=template&id=79dde210&scoped=true&ts=true"
import script from "./GroupLayoutRenderer.vue?vue&type=script&lang=ts"
export * from "./GroupLayoutRenderer.vue?vue&type=script&lang=ts"

import "./GroupLayoutRenderer.vue?vue&type=style&index=0&id=79dde210&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79dde210"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
